import config from '../../config';
import { GraphQLClient } from 'graphql-request';
import { tokenInvalidOrExpired } from './auth.util';
import { store } from '../store';
import { logout } from '../actions/auth.action';

export const makeApolloClient = (state, token) => {
	const auth0Token = token || state.auth.auth0Token;
	if (!auth0Token) {
		store.dispatch(logout());
		return console.log('⚠️ Token invalid ⚠️');
	}
	const tokenIsExpired = tokenInvalidOrExpired(auth0Token);
	if (tokenIsExpired) {
		store.dispatch(logout());
		return console.log('⚠️ Token is invalid or has expired ⚠️');
	}

	return new GraphQLClient(`${config.serverUrl}/graphql/admin`, {
		headers: {
			Authorization: `Bearer ${auth0Token}`,
		},
	});
};

export const arrToObj = (data, formatter, key = 'id') =>
	Array.isArray(data)
		? data.reduce((acc, datum) => {
				formatter ? (acc[datum[key]] = formatter(datum)) : (acc[datum[key]] = datum);
				return acc;
		  }, {})
		: data;

export const logError = (error, location) => {
	console.log(`🚨 Error Occured IN ${location} 🚨 ${error}`);
	return { error, location };
};

export {
	isSuperAdmin,
	isValidClientAdmin,
	isValidEventAdmin,
	hasSomeRoleInEvent,
	isSaaSAdmin,
	tokenInvalidOrExpired,
} from './auth.util';
export { parseEvent, normalizeEvent } from './event.util';
export { parseClient, getAdminClients } from './client.util';
